import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import React, { useCallback, useState } from 'react'

export function useConfirmationDialogController({ onConfirm }) {
    const [isDialogOpen, setDialogOpen] = useState(false)

    const openDialog = useCallback(() => setDialogOpen(true), [])

    const closeDialog = useCallback(() => setDialogOpen(false), [])

    const confirmDialog = useCallback(() => {
        onConfirm()
        setDialogOpen(false)
    }, [onConfirm])

    return {
        isDialogOpen,
        openDialog,
        closeDialog,
        confirmDialog,
    }
}

export const ConfirmationDialog = ({
    message = 'Are you sure you want perform that action?',
    controller: { isDialogOpen, closeDialog, confirmDialog },
}) => (
    <Dialog open={isDialogOpen} onClose={closeDialog}>
        <DialogTitle>{message}</DialogTitle>
        <DialogActions>
            <Button onClick={closeDialog}  color="secondary">
                Cancel
            </Button>
            <Button onClick={confirmDialog} variant="outlined" color="primary" autoFocus>
                Confirm
            </Button>
        </DialogActions>
    </Dialog>
)
